<div class="navbar-wrapper"
  [ngClass]="{'container': this.gradientConfig.layout === 'horizontal' && this.gradientConfig.subLayout === 'horizontal-2'}">
  <div class="flex text-center">

    <img id="logo" src="../../../../../assets/images/logo-2.png">
  </div>
  <!-- <h6 id="title-text-c" style="color: black; margin-bottom: 2%;font-size: 18px;">
    การบริหารงานพัฒนาท้องถิ่นที่ยั่งยืน (รุ่นที่6)
  </h6> -->
  <app-nav-content (onNavMobCollapse)="navMobCollapse()"></app-nav-content>
</div>